import HOCAddPatient from '@components/hoc-add-patient';
import useDebounce from '@hooks/utils/useDebounce';
import { FilterOutlined, PlusOutlined, SearchOutlined } from '@icon';
import { Badge, Dropdown, IconButton, TextField } from '@ui';
import React from 'react';

const Btn = ({ onAddPatient }: any) => (
  <IconButton size="medium" variant="primary" onClick={onAddPatient} Icon={PlusOutlined} />
);

const WrappedBtn = HOCAddPatient(Btn);

interface PatientsFilterProps {
  refetch: () => void;
  onParamsChange: (params: TSearchValues) => void;
}

export type TSearchValues = {
  query: string;
  clients: 'my' | 'all';
};

const PatientsFilter: React.FunctionComponent<PatientsFilterProps> = ({
  refetch,
  onParamsChange,
}) => {
  const [searchValues, setSearchValues] = React.useState<TSearchValues>({
    query: '',
    clients: 'my',
  });
  const debounced = useDebounce(searchValues, 500);

  React.useEffect(() => {
    onParamsChange(debounced);
  }, [debounced]);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
      <TextField
        right={<TextField.Icon Icon={SearchOutlined} />}
        value={searchValues.query}
        onChange={(e) => {
          setSearchValues((o) => ({ ...o, query: e.target.value }));
        }}
        clearable
        style={{ minWidth: 267 }}
      />
      <Dropdown
        menu={{
          items: [
            { key: 'all', label: 'Všetci' },
            { key: 'my', label: 'Moji klienti' },
          ],
          selectMode: 'single',
          selectedKeys: [searchValues.clients],
          onSelect: (e) => {
            setSearchValues((o) => ({ ...o, clients: e.key as any }));
          },
        }}
        trigger={['click']}
        placement="bottomRight"
      >
        <div style={{ position: 'relative' }}>
          <Badge
            content={searchValues.clients !== 'all' ? 1 : 0}
            positionHorizontal="right"
            positionVertical="top"
          >
            <IconButton size="medium" variant="secondary" Icon={FilterOutlined} />
          </Badge>
        </div>
      </Dropdown>
      <WrappedBtn afterSubmit={() => refetch()} />
    </div>
  );
};

export default PatientsFilter;
